import DataStreamSetupScreen from './DataStreamSetupScreen';

export default DataStreamSetupScreen;
